module.exports = __webpack_public_path__ + "images/旅悦好物全景_04-2.jpg?v=f43625cb";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/lvyue3/旅悦好物全景_04-2.jpg
 ** module id = 133
 ** module chunks = 1 2
 **/